import React from "react";
import CardLayout from "../../common/cardLayout/CardLayout";
import "./ResourcesStyles.css";
import BHIGuideline from "../../../assets/HelpfulMaterials/BHI and CoCM Guidelines.pdf"
import BHIOverview from "../../../assets/HelpfulMaterials/BHI Provider Overview.pdf"
import liveCoaching from "../../../assets/HelpfulMaterials/Live Coaching Using Chat Features.pdf"
import marketing from "../../../assets/HelpfulMaterials/Marketing Rose for Success.pdf"
import onboardingProcess from "../../../assets/HelpfulMaterials/Rose New Account Onboarding Process.pdf"
import adultPatientPoster from "../../../assets/HelpfulMaterials/Rose Patient Poster.pdf"
import adultPrescription from "../../../assets/HelpfulMaterials/Rose Prescription Pad.pdf"
import trifold from "../../../assets/HelpfulMaterials/Rose Trifold Brochure.pdf"
import roseYouthFlyer from "../../../assets/HelpfulMaterials/Rose Youth Flyer.pdf"
import patientPoster from "../../../assets/HelpfulMaterials/Rose Youth Patient Poster_FINAL.pdf"
import youthPrescription from "../../../assets/HelpfulMaterials/Rose Youth Prescription Pads_Final.pdf"
import instructionManual from "../../../assets/HelpfulMaterials/Rose Instruction Manual_1.24.24.pdf"
import letter from "../../../assets/HelpfulMaterials/Letter to Patient-Rose Youth Intro.docx"
import adultLetter from "../../../assets/HelpfulMaterials/Rose Intro Letter to Patient  Template.docx"
import { disable } from "mixpanel-browser";
const MaterialPill = ({ text, link = "", disabled=false }) => {
  return (
    <div className="material-pill mb-3">
      <label>{text}</label>
      <div className="d-flex" style={{ gap: "10px" }}>
        {/* <button style={{ borderRadius: "8px" }} className="btn primary-btn">
          View
        </button> */}
        {/* <button style={{ borderRadius: "8px" }} className="btn primary-btn">
          Download
        </button> */}
        {!disabled?( <a href={link} style={{ borderRadius: "8px" }} className="btn primary-btn " target="_blank">View</a>) : (
          <a href={link} style={{ borderRadius: "8px" }} className="btn primary-btn disabled" target="_blank">View</a>
        )}
        
        <a href={link} style={{ borderRadius: "8px" }} className="btn primary-btn" target="_blank" download>Download</a>
      </div>
    </div>
  );
};

const HelpfulMaterials = () => {
  return (
    <CardLayout>
      <div className="container-fluid d-flex justify-content-start w-100 py-3">
        <h5 className="muted-text">Helpful Materials</h5>
      </div>
      <div className="container-fluid py-2">
        <strong style={{ color: "#1E293B" }}>
          {/* <label>Provider Resources</label> */}
          {process.env.REACT_APP_DASHBOARD_TYPE === "youth"? (
          <div className="container-fluid py-3 ">
            <MaterialPill text={"BHI and CoCM Guidelines"} link={BHIGuideline} />
            <MaterialPill text={"BHI Provider Overview"} link={BHIOverview}/>
            <MaterialPill text={"Live Coaching Using Chat Features"} link={liveCoaching}/>
            <MaterialPill text={"Marketing Rose for Success"} link={marketing}/>
            <MaterialPill text={"Rose Youth Flyer"} link={roseYouthFlyer}/>
            <MaterialPill text={"Rose Youth Patient Poster"} link={patientPoster}/>
            <MaterialPill text={"Rose Youth Prescription Pads"} link={youthPrescription}/>
            <MaterialPill text={"Rose Instruction Manual"} link={instructionManual}/>
            <MaterialPill text={"Rose Youth Patient Overview video"} link={"https://youtu.be/6aob7XqlRaw"}/>
            <MaterialPill text={"Letter to Patient-Rose Youth Intro"} link={letter}  disabled={true}/>
          </div>):
          (<div className="container-fluid py-3 ">
          <MaterialPill text={"BHI and CoCM Guidelines"} link={BHIGuideline} />
          <MaterialPill text={"BHI Provider Overview"} link={BHIOverview}/>
          <MaterialPill text={"Live Coaching Using Chat Features"} link={liveCoaching}/>
          <MaterialPill text={"Marketing Rose for Success"} link={marketing}/>
          <MaterialPill text={"Rose New Account Onboarding Process"} link={onboardingProcess}/>
          <MaterialPill text={"Rose Patient Poster"} link={adultPatientPoster}/>
          <MaterialPill text={"Rose Prescription Pad"} link={adultPrescription}/>
          <MaterialPill text={"Rose Trifold Brochure"} link={trifold}/>
          <MaterialPill text={"Rose Intro Letter to Patient"} link={adultLetter} disabled={true}/>
          <MaterialPill text={"Rose Patient Overview video"} link={"https://youtu.be/7atNBdMvXD0"}/>
        </div>)}
        </strong>
      </div>
    </CardLayout>
  );
};

export default HelpfulMaterials;
